import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Import per component
import commonEn from "./locales/en/common.json";
import navBarEn from "./locales/en/navBar.json";
import footerEn from "./locales/en/footer.json";
import contactUsEn from "./locales/en/contactUs.json";
import aboutCompanyEn from "./locales/en/aboutCompany.json";
import servicesEn from "./locales/en/servicesSection.json";
import industriesHomeEn from "./locales/en/industriesSection.json";
import solutionsHomeEn from "./locales/en/solutionsSection.json";
import aboutUsEn from "./locales/en/aboutUs.json";
import messageUsEn from "./locales/en/message.json";
import corporateEn from './locales/en/corporatePhilosophy.json';
import businessEthicsEn from './locales/en/businessEthics.json';


import commonJp from "./locales/jp/common.json";
import navBarJp from "./locales/jp/navBar.json";
import footerJp from "./locales/jp/footer.json";
import contactUsJp from "./locales/jp/contactUs.json";
import aboutCompanyJp from "./locales/jp/aboutCompany.json";
import servicesJp from "./locales/jp/servicesSection.json";
import industriesHomeJp from "./locales/jp/industriesSection.json";
import solutionsHomeJp from "./locales/jp/solutionsSection.json";
import aboutUsJp from "./locales/jp/aboutUs.json";
import messageUsJp from "./locales/jp/message.json";
import corporateJp from './locales/jp/corporatePhilosophy.json';
import businessEthicsJp from './locales/jp/businessEthics.json';

const savedLang = localStorage.getItem("i18nextLng") || "en";

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: commonEn,
        navBar: navBarEn,
        footer: footerEn,
        contactUs: contactUsEn,
        aboutCompany: aboutCompanyEn,
        services: servicesEn,
        industriesHome: industriesHomeEn,
        solutionsHome: solutionsHomeEn,
        aboutUs: aboutUsEn,
        message: messageUsEn,
        corporatePhilosophy: corporateEn,
        businessEthics: businessEthicsEn,
      },
      jp: {
        common: commonJp,
        navBar: navBarJp,
        footer: footerJp,
        contactUs: contactUsJp,
        aboutCompany: aboutCompanyJp,
        services: servicesJp,
        industriesHome: industriesHomeJp,
        solutionsHome: solutionsHomeJp,
        aboutUs: aboutUsJp,
        message: messageUsJp,
        corporatePhilosophy: corporateJp,
        businessEthics: businessEthicsJp,
      }
    },
    lng: savedLang,
    fallbackLng: "en",
    ns: [
      "common",
      "navBar",
      "footer",
      "contactUs",
      "aboutCompany",
      "services",
      "industriesHome",
      "solutionsHome",
      "aboutUs",
      "message",
      "corporatePhilosophy",
      "businessEthics",
    ], // list namespaces
    defaultNS: "common",
    interpolation: { escapeValue: false }
  });

export default i18n;
